import { Injectable } from '@angular/core';
import { CalculationResponse } from '../../../../../../../common/dist/angular/responses/calculation.response';
import { LoggingService } from '../../core/services/logging.service';
import { OptitaxFileManager } from '../../core/managers/optitax-file.manager';
import { ExportTypeEnum } from '../../../../../../../common/src/enums/export-type.enum';
import { FileFillerFactory } from '../../../../../../../common/src/exports/factories/file-filler.factory';

@Injectable()
export class ExportManager {

  constructor(
    private readonly fileFillerFactory: FileFillerFactory,
    private readonly optitaxFileManager: OptitaxFileManager,
    private readonly loggingService: LoggingService,
  ) {
  }

  download(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();

    window.URL.revokeObjectURL(url);
    // Remove the link
    link.remove();
  }

  async exportOptitax(calculation: CalculationResponse): Promise<void> {
    const optitaxFile = this.optitaxFileManager.exportOptitaxFile(calculation);

    const blob = new Blob([JSON.stringify(optitaxFile)], { type: 'application/json' });
    this.download(blob, `${calculation.id}.optitax`);
  }

  async exportExcel(calculation: CalculationResponse): Promise<void> {
    const fileFiller = this.fileFillerFactory.getFileFiler(ExportTypeEnum.XLSX, calculation);
    const exportedFile = await fileFiller.fill(calculation);

    const blob = new Blob([exportedFile.fileBytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const file = new File([blob], `${exportedFile.fileName}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    this.download(file, exportedFile.fileName);
  }

  async exportPdf(calculation: CalculationResponse): Promise<void> {
    const fileFiller = this.fileFillerFactory.getFileFiler(ExportTypeEnum.PDF, calculation);
    const exportedFile = await fileFiller.fill(calculation);

    const blob = new Blob([exportedFile.fileBytes], { type: 'application/pdf' });
    this.download(blob, exportedFile.fileName);
  }
}
